/**
 * Capacity: how many hours a week can actually be planned.
 *
 * Monthly capacity is the number Noorix configures; everything downstream is
 * derived from it. The 12/52 conversion is deliberate — a month is not four
 * weeks, and using 4 would overstate weekly capacity by about 8%.
 */
/** A month is 12/52 of a year's weeks, not 4. */
export const WEEKS_PER_MONTH = 12 / 52;
/** Load below this share of plannable capacity reads as Light. */
export const LOAD_BAND_LIGHT_MAX_PCT = 70;
/** Load above this share of plannable capacity reads as Overloaded. */
export const LOAD_BAND_LOADED_MAX_PCT = 100;
export function capacity(config) {
    const { monthlyHours, hotfixReservePct } = config;
    if (!Number.isFinite(monthlyHours) || monthlyHours < 0) {
        throw new RangeError(`monthlyHours must be a non-negative number, got ${monthlyHours}`);
    }
    if (!Number.isFinite(hotfixReservePct) || hotfixReservePct < 0 || hotfixReservePct > 100) {
        throw new RangeError(`hotfixReservePct must be between 0 and 100, got ${hotfixReservePct}`);
    }
    const weekly = monthlyHours * WEEKS_PER_MONTH;
    return {
        monthlyHours,
        hotfixReservePct,
        weeklyHours: Math.round(weekly),
        reserveHours: Math.round((weekly * hotfixReservePct) / 100),
        plannableHours: Math.round(weekly * (1 - hotfixReservePct / 100)),
    };
}
/** Load as a percentage of plannable capacity. Zero capacity with load is infinite, reported as 100+. */
export function loadPct(loadHours, plannableHours) {
    if (plannableHours <= 0)
        return loadHours > 0 ? Number.POSITIVE_INFINITY : 0;
    return (loadHours / plannableHours) * 100;
}
export function loadBand(loadHours, plannableHours) {
    const pct = loadPct(loadHours, plannableHours);
    if (pct < LOAD_BAND_LIGHT_MAX_PCT)
        return 'light';
    if (pct <= LOAD_BAND_LOADED_MAX_PCT)
        return 'loaded';
    return 'overloaded';
}
//# sourceMappingURL=capacity.js.map